/*
==========================================================
IMPORTS
==========================================================
*/

import AuthLayout from "../../../components/platform/auth/AuthLayout/AuthLayout";

import LoginForm from "../../../components/platform/auth/LoginForm/LoginForm";

/*
==========================================================
PAGE
==========================================================
*/

export default function LoginPage() {

  return (

    <AuthLayout>

      <LoginForm />

    </AuthLayout>

  );

}